<template>
  <div>
    <div class="container container-home">
      <div class="bg-card mt-3 p-5">
        <div
          v-if="emailSendSuccess"
          class="success-notif"
        >
          <b-alert
            variant="success"
            text="asd"
            show
          >
            {{ $t('pages.contact-us.success') }}
          </b-alert>
          <b-button
            class="mt-3"
            variant="success"
            @click="$router.push({ name: 'search-offers'})"
          >
            {{ $t('pages.contact-us.search-offers') }}
          </b-button>
        </div>
        <div
          v-if="!emailSendSuccess"
          class="contact-form mx-auto text-left"
        >
          <h1 class="mb-4 text-center">
            {{ $t('pages.contact-us.title') }}
          </h1>
          <b-form-group>
            <label>{{ $t('pages.contact-us.form.type') }}</label>
            <b-form-select
              v-model="$v.form.type.$model"
              :state="$v.form.type.$dirty ? !$v.form.type.$error : null"
              :options="typeOptions"
            />
          </b-form-group>
          <b-form-group>
            <label>{{ $t('pages.contact-us.form.subject') }}</label>
            <b-form-input
              v-model="$v.form.subject.$model"
              :state="$v.form.subject.$dirty ? !$v.form.subject.$error : null"
            />
          </b-form-group>
          <b-form-group>
            <label>{{ $t('pages.contact-us.form.text') }}</label>
            <b-form-textarea
              v-model="$v.form.content.$model"
              :state="$v.form.content.$dirty ? !$v.form.content.$error : null"
              rows="5"
            />
            <div class="content-count">
              {{ contentLength }}/2000
            </div>
          </b-form-group>
          <b-form-group class="mt-5">
            <label>{{ $t('pages.contact-us.form.name') }}</label>
            <b-form-input
              v-model="$v.form.name.$model"
              :state="$v.form.name.$dirty ? !$v.form.name.$error : null"
            />
          </b-form-group>
          <b-form-group>
            <label>{{ $t('pages.contact-us.form.email') }}</label>
            <b-form-input
              v-model="$v.form.email.$model"
              :state="$v.form.email.$dirty ? !$v.form.email.$error : null"
            />
          </b-form-group>
          <p class="privacy">
            {{ $t('pages.contact-us.privacy-notice') }}
            <router-link :to="{ name: 'privacy-policy' }">
              {{ $t('pages.contact-us.privacy-policy-link') }}. <!-- there's a DOT at the end!! -->
            </router-link>
          </p>
          <b-button
            variant="info"
            class="send-btn"
            style="text-transform: uppercase;"
            @click="validate"
          >
            {{ $t('generic.send') }}
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import contactFormTypes from "../assets/data/contactFormTypes";
import { required, minLength, maxLength, email } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      emailSendSuccess: false,
      form: {
        type: null,
        subject: "",
        content: "",
        name: "",
        email: ""
      },
    }
  },
  computed: {
    typeOptions: () => contactFormTypes(),
    contentLength() {
      return this.form.content.length;
    }
  },
  validations: {
    form: {
      type: { required },
      subject: { required, minLength: minLength(4) },
      content: { required, minLength: minLength(10), maxLength: maxLength(2000) },
      name: { required },
      email: { required, email }
    }
  },
  methods: {
    validate() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$toastNotification('danger', '', this.$t('pages.contact-us.validation.error', 'Please correct the errors in the form'));
        return false;
      } else {
        this.submit();
        return true;
      }
    },
    submit() {
      this.axios.post('/contacts/send', this.form)
        .then(() => {
          this.emailSendSuccess = true;
        })
        .catch();
    }
  }
}
</script>

<style scoped>
  @media screen and (min-width: 768px) {
    .contact-form {
      width: 50%;
    }
  }

  p.privacy {
    font-size: 0.85rem;
  }

  .send-btn {
    font-size: 0.9rem;
    font-weight: 600;
    letter-spacing: 0.2px;
    text-transform: uppercase;
  }

  .content-count {
    color: #aaa;
    font-size: 0.95rem;
  }

  .success-notif {
    padding: 10rem 0;
  }

  .bg-card {
    background: white;
  }
</style>
